import CalendarPage from "./CalendarPage";
import { CalendarListView } from "./ListView/CalendarListView";
import { useCalendarMode } from "./useCalendarMode";

export const CalendarRoute = () => {
  const [mode] = useCalendarMode();

  return mode === "list" ? <CalendarListView /> : <CalendarPage />;
};
